var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckBalloon = function SvgCheckBalloon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#83ACEB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.5 21.364a9 9 0 1 0-8-4.873l-1 4.873 4.873-1c1.236.639 2.64 1 4.127 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#83ACEB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m15.5 10.364-4 4-2-2"
  })));
};
export default SvgCheckBalloon;